export var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Available"] = "available";
    AvailabilityStatus["Away"] = "away";
})(AvailabilityStatus || (AvailabilityStatus = {}));
export var AVAILABILITY_STATUS = {
    AVAILABLE: AvailabilityStatus.Available,
    AWAY: AvailabilityStatus.Away,
};
//# sourceMappingURL=availability-status.js.map